import { Component, OnInit, ViewChild } from '@angular/core';
import { AcuerdoPagoService } from '../../services/acuerdo-pago.service';
import { PaginationComponent } from '../../components/pagination/pagination.component';

@Component({
  selector: 'app-aprobaciones',
  templateUrl: './aprobaciones.component.html',
  styleUrls: ['./aprobaciones.component.scss']
})
export class AprobacionesComponent implements OnInit {
  headersAcuerdoPago:any[]=[]
  listAcuerdoPagoPorAprobar:any[]=[]
  showModalAprobacion:boolean=false
  paginationAcuerdos:any={
    hasNextPage:false,
    hasPrevPage:false,
    totalPages:[],
    page:0
  }

  @ViewChild("paginationAcuerdos",{static:false}) paginadorAcuerdos:PaginationComponent;

  constructor(
    private acuerdoPagoService:AcuerdoPagoService
  ) { 
    this.headersAcuerdoPago=[
      {
        label: "Cliente",
        key: "_id",
        subKey:"cliente",
        customClass: "aprobaciones",
        type:"data-cuenta-acuerdo"
      },
      {
        label: "Nro Documento",
        key: "_id",
        subKey:"nro_documento",
        customClass: "aprobaciones",
        type:"data-cuenta-acuerdo"
      },
      {
        label: "Operacion/Cuenta",
        key: "_id",
        subKey:"cuenta",
        customClass: "aprobaciones",
        type:"data-cuenta-acuerdo"
      },
      {
        label: "Fecha Acuerdo",
        key: "_id",
        subKey:"fecha_acuerdo",
        customClass: "aprobaciones",
        type:"data-cuenta-acuerdo"
      },
      {
        label: "Saldo Capital",
        key: "saldo_capital",
        subKey:"",
        customClass: "aprobaciones",
        type:"decimal"
      },
      {
        label: "Monto Campaña",
        key: "monto_campana",
        subKey:"",
        customClass: "aprobaciones",
        type:"decimal"
      },
      {
        label: "Monto Acuerdo",
        key: "total",
        subKey:"$numberDecimal",
        customClass: "aprobaciones",
        type:"money"
      },
      {
        label: "Monto Acuerdo",
        key: "porcentaje_acuerdo",
        subKey:"",
        customClass: "aprobaciones",
        type:"porcentaje"
      },
      {
        label: "",
        key: "_id",
        subKey:"",
        customClass: "aprobaciones",
        type:"buttonAprobar"
      }

    ]
  }

  ngOnInit() {
    this.acuerdoPagoService.getAcuerdoPagoPendienteAprobacion("").subscribe((data:any)=>{
      let perfil:string=sessionStorage.getItem("perfil")
      for(let acuerdo of data.acuerdos_pago_por_aprobar.docs){
        acuerdo.monto_campana=(acuerdo._id.saldo_capital.$numberDecimal)/2
        acuerdo.porcentaje_acuerdo=((acuerdo.total.$numberDecimal/acuerdo._id.saldo_capital.$numberDecimal)*100).toFixed(2)
        acuerdo.saldo_capital=acuerdo._id.saldo_capital.$numberDecimal
        acuerdo.puede_aprobar=(acuerdo.porcentaje_acuerdo>=35)?"Analista":((acuerdo.porcentaje_acuerdo<=35)?"Operaciones":"")
        acuerdo.perfil=perfil
      }

      

      this.listAcuerdoPagoPorAprobar=data.acuerdos_pago_por_aprobar.docs
      this.paginationAcuerdos.hasNextPage=data.acuerdos_pago_por_aprobar.hasNextPage
      this.paginationAcuerdos.hasPrevPage=data.acuerdos_pago_por_aprobar.hasPrevPage
      this.paginationAcuerdos.totalPages=new Array(data.acuerdos_pago_por_aprobar.totalPages)
      this.paginationAcuerdos.page=data.acuerdos_pago_por_aprobar.page
      this.paginadorAcuerdos.pagParams=this.paginationAcuerdos
    })
  }

  refreshPageAcuerdos(page:any){
    this.acuerdoPagoService.getAcuerdoPagoPendienteAprobacion("?page="+page).subscribe((data:any)=>{
      let perfil:string=sessionStorage.getItem("perfil")
      for(let acuerdo of data.acuerdos_pago_por_aprobar.docs){
        acuerdo.monto_campana=(acuerdo._id.saldo_capital.$numberDecimal)/2
        acuerdo.porcentaje_acuerdo=((acuerdo.total.$numberDecimal/acuerdo._id.saldo_capital.$numberDecimal)*100).toFixed(2)
        acuerdo.saldo_capital=acuerdo._id.saldo_capital.$numberDecimal
        acuerdo.puede_aprobar=(acuerdo.porcentaje_acuerdo>=35)?"Analista":((acuerdo.porcentaje_acuerdo<=35)?"Operaciones":"")
        acuerdo.perfil=perfil
      }

      this.listAcuerdoPagoPorAprobar=data.acuerdos_pago_por_aprobar.docs
      this.paginationAcuerdos.hasNextPage=data.acuerdos_pago_por_aprobar.hasNextPage
      this.paginationAcuerdos.hasPrevPage=data.acuerdos_pago_por_aprobar.hasPrevPage
      this.paginationAcuerdos.totalPages=new Array(data.acuerdos_pago_por_aprobar.totalPages)
      this.paginationAcuerdos.page=data.acuerdos_pago_por_aprobar.page
      this.paginadorAcuerdos.pagParams=this.paginationAcuerdos
    })
  }

  filterGrid(filter:any){
    let filterQuery:string=""
    if(filter.target.id=="nro_documento"){
      filterQuery="nro_documento="+filter.target.value
    }

    if(filter.target.id=="nombre_cliente"){
      filterQuery="cliente="+filter.target.value
    }
    
    this.acuerdoPagoService.getAcuerdoPagoPendienteAprobacion("?page=1&"+filterQuery).subscribe((data:any)=>{
      let perfil:string=sessionStorage.getItem("perfil")
      for(let acuerdo of data.acuerdos_pago_por_aprobar.docs){
        acuerdo.monto_campana=(acuerdo._id.saldo_capital.$numberDecimal)/2
        acuerdo.porcentaje_acuerdo=((acuerdo.total.$numberDecimal/acuerdo._id.saldo_capital.$numberDecimal)*100).toFixed(2)
        acuerdo.saldo_capital=acuerdo._id.saldo_capital.$numberDecimal
        acuerdo.puede_aprobar=(acuerdo.porcentaje_acuerdo>=35)?"Analista":((acuerdo.porcentaje_acuerdo<=35)?"Operaciones":"")
        acuerdo.perfil=perfil
      }

      this.listAcuerdoPagoPorAprobar=data.acuerdos_pago_por_aprobar.docs
      this.paginationAcuerdos.hasNextPage=data.acuerdos_pago_por_aprobar.hasNextPage
      this.paginationAcuerdos.hasPrevPage=data.acuerdos_pago_por_aprobar.hasPrevPage
      this.paginationAcuerdos.totalPages=new Array(data.acuerdos_pago_por_aprobar.totalPages)
      this.paginationAcuerdos.page=data.acuerdos_pago_por_aprobar.page
      this.paginadorAcuerdos.pagParams=this.paginationAcuerdos
    })

   
  }

  datoParaAprobar:any=""
  aprobarAP(acuerdo:any){
    this.datoParaAprobar=acuerdo
    this.showModalAprobacion=true
  }

  enviarAprobacion(){
    let dataSend:any={
      cuenta:this.datoParaAprobar._id.cuenta,
      fecha_acuerdo:this.datoParaAprobar._id.fecha_acuerdo,
      nro_documento:this.datoParaAprobar._id.nro_documento,
      necesita_validacion:false,
      fecha_aprobacion:this.getFecActual()
    }

    this.acuerdoPagoService.aprobarAcuerdo(dataSend).subscribe((data:any)=>{
      //console.log(dataSend)
      this.refreshPageAcuerdos(1)
      this.closeModal()
    })

    
  }

  getFecActual(){
    let hoy = new Date();
    let i=0;
    let fecha = hoy.getDate()+ '/' + ((hoy.getMonth())+1) + '/' + hoy.getFullYear();
    let mes:any=((hoy.getMonth())+1);
    mes=(mes.toString().length==1)?"0"+mes:mes;
    let dia:any=hoy.getDate();
    dia=(dia.toString().length==1)?"0"+dia:dia;
    return hoy.getFullYear()+"-"+mes+"-"+dia
  }

  closeModal(){
    this.datoParaAprobar=""
    this.showModalAprobacion=false
  }
}
